export var DataState;
(function (DataState) {
    DataState["NOT_ASKED"] = "NotAsked";
    DataState["LOADING"] = "Loading";
    DataState["FAILURE"] = "Failure";
    DataState["SUCCESS"] = "Success";
})(DataState || (DataState = {}));
export var GlobalSearchResultTypes;
(function (GlobalSearchResultTypes) {
    GlobalSearchResultTypes["RESIDENT"] = "resident";
    GlobalSearchResultTypes["OWNER"] = "owner";
    GlobalSearchResultTypes["DOOR"] = "door";
    GlobalSearchResultTypes["TASK"] = "task";
    GlobalSearchResultTypes["VENDOR"] = "vendor";
    GlobalSearchResultTypes["LEASE"] = "lease";
    GlobalSearchResultTypes["BUILDING"] = "building";
    GlobalSearchResultTypes["WORK_ORDER"] = "work_order";
    GlobalSearchResultTypes["TAG"] = "tag";
    GlobalSearchResultTypes["APPLICATION_PERSON"] = "application_person";
})(GlobalSearchResultTypes || (GlobalSearchResultTypes = {}));
export var EntitySearchResultTypes;
(function (EntitySearchResultTypes) {
    EntitySearchResultTypes["APPLICATION_PERSON"] = "application_person";
    EntitySearchResultTypes["CONTACT_VENDOR"] = "contact_vendor";
    EntitySearchResultTypes["CONTACT_OWNER"] = "contact_owner";
    EntitySearchResultTypes["CONTACT_RESIDENT"] = "contact_resident";
    EntitySearchResultTypes["CONTACT_EXTERNAL"] = "contact_external";
    EntitySearchResultTypes["CONTACT_EMPLOYEE"] = "contact_employee";
    EntitySearchResultTypes["VENDOR"] = "vendor";
    EntitySearchResultTypes["LEASE"] = "lease";
    EntitySearchResultTypes["DOOR"] = "door";
    EntitySearchResultTypes["RESIDENT"] = "resident";
    EntitySearchResultTypes["OWNER"] = "owner";
    EntitySearchResultTypes["BUILDING"] = "building";
    EntitySearchResultTypes["WORK_ORDER"] = "work_order";
})(EntitySearchResultTypes || (EntitySearchResultTypes = {}));
export var SearchTypes;
(function (SearchTypes) {
    SearchTypes["ALL"] = "all";
    SearchTypes["APPLICATION_PERSON"] = "application_person";
    SearchTypes["CONTACT"] = "contact";
    SearchTypes["CONTACT_VENDOR"] = "contact_vendor";
    SearchTypes["CONTACT_OWNER"] = "contact_owner";
    SearchTypes["CONTACT_RESIDENT"] = "contact_resident";
    SearchTypes["CONTACT_EXTERNAL"] = "contact_external";
    SearchTypes["CONTACT_EMPLOYEE"] = "contact_employee";
    SearchTypes["RESIDENT"] = "resident";
    SearchTypes["DOOR"] = "door";
    SearchTypes["BUILDING"] = "building";
    SearchTypes["LEASE"] = "lease";
    SearchTypes["OWNER"] = "owner";
    SearchTypes["VENDOR"] = "vendor";
    SearchTypes["WORK_ORDER"] = "work_order";
    SearchTypes["TAG"] = "tag";
})(SearchTypes || (SearchTypes = {}));
